import IMAGES from '../assets/images';
import CustomImage from '../components/CustomImage';

const AuthLayout = ({
  children,
  leftContent,
}: {
  children: React.ReactNode;
  leftContent?: React.ReactNode;
}) => {
  return (
    <div className="relative grid grid-cols-1 lg:grid-cols-3 bg-theme-slate-900 h-screen overflow-hidden">
      <div className="hidden lg:flex relative overflow-hidden col-span-1 flex-col items-center w-full grow bg-theme-slate-800">
        {leftContent}
        <div className="absolute left-[-210px] bottom-[-210px] w-full opacity-10 z-0">
          <CustomImage
            src={IMAGES.xLogo}
            alt="x_logo"
            height={850}
            width={850}
            className="w-full h-full max-w-full max-h-full"
          />
        </div>
      </div>
      <div className="md:col-span-2 p-10 overflow-x-hidden overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export const TimelineIcon = ({
  Icon,
  isActive,
}: {
  Icon: React.ElementType;
  isActive?: boolean;
}) => (
  <div
    className={`w-[60px] h-[60px] rounded-full border-2 border-white flex items-center justify-center ${
      isActive ? 'bg-white text-theme-slate-900' : 'bg-transparent text-white'
    }`}
  >
    <Icon className="text-2xl" />
  </div>
);

export const TimelineContent = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => (
  <div>
    <h2 className="text-white text-2xl font-semibold m-0">{title}</h2>
    <p className="text-white text-lg">{subtitle}</p>
  </div>
);

export default AuthLayout;
